import moment from 'moment'

export function filterDate(val) {
    if (!val) return ''
    if (val.indexOf('T') > -1) {
        return val.split('T')[0]
    }
    return val.split(' ')[0]

}
// 根据opinion转为文字 -1 反对 0 同意 1 有条件同意
export function opinionTxt(val) {
    if (!val && val != 0) return ''
    if (val == 0) {
        return '同意'
    } else if (val == -1) {
        return '反对'
    } else if (val == 1) {
        return '有条件同意'
    }
    return ''
}
export function timeFormant(val) {
    if (!val) return '--'
    let newTime = new Date(val)
    let Y = newTime.getFullYear()
    let M = (newTime.getMonth() + 1) > 9 ? (newTime.getMonth() + 1) : '0' + (newTime.getMonth() + 1)
    let D = newTime.getDate() > 9 ? newTime.getDate() : '0' + newTime.getDate()
    return Y + '-' + M + '-' + D
}
/**
 *
 * @param {*} time 标准时间
 * @param {*} format 时间格式 默认YYYY-MM-DD
 */
export function formatNormatTime(time, format, minute) {
    if (!time) return
    let newTime = new Date(time)
    let Y = newTime.getFullYear()
    let M = (newTime.getMonth() + 1) > 9 ? (newTime.getMonth() + 1) : '0' + (newTime.getMonth() + 1)
    let D = newTime.getDate() > 9 ? newTime.getDate() : '0' + newTime.getDate()
    let H = newTime.getHours() > 9 ? newTime.getHours() : '0' + newTime.getHours()
    let m = newTime.getMinutes() > 9 ? newTime.getMinutes() : '0' + newTime.getMinutes()
    let S = newTime.getSeconds() > 9 ? newTime.getSeconds() : '0' + newTime.getSeconds()
    let reg = /[-/年]/gi
    if (reg.test(format)) {
        return Y + '-' + M + '-' + D + '  ' + H + ':' + m + ':' + S
    }
    if (minute) {
        return Y + '-' + M + '-' + D + '  ' + H + ':' + m
    }
    return Y + '-' + M + '-' + D
}
/**
 * 数字千分位
 * @param {Number,Sting}
 * @return String
 */
export function NumFormat(value) {
    if (!value && value !== 0) return '--'
    const arrValue = value.toString().split('.')
    let floatNum = arrValue[1]
    const intPart = arrValue[0]
    floatNum = floatNum === undefined ? '' : '.' + floatNum
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    const endNumStr = intPartFormat + floatNum
    return endNumStr
}
/**
 * 跟投情况
 * @param {*} data
 */
export function transformation(data) {
    if (data == 1) {
        return '上档'
    }
    if (data == 2) {
        return '中档'
    }
    if (data == 3) {
        return '下档'
    }
    return '--'
}
/**
 * 有值加单位，无则加 --
 * @param {Number,Sting}
 * @return String
 */
export function unitFormat(value, unit) {
    if (!value && value !== 0) return '--'
    if (!unit) {
        unit = ''
    }
    const valueString = value.toString() + ' ' + unit
    return valueString
}
/**
 * @description 时间格式化
 * @param {Number} time 非时间戳
 * @param {String} cFormat 时间格式
 */
export function newParseTime(time, cFormat) {
    if (!time) return '--'
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        date = moment(time)
    }
    const formatObj = {
        y: date.year(),
        m: date.month() + 1,
        d: date.date(),
        h: date.hour(),
        i: date.minute(),
        s: date.second(),
        a: date.day()
    }
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return timeStr
}

/**
 * 有值加单位，无则加 --
 * @param {Number,Sting}
 * @return String
 */
export function keepInteger(value, type) {
    if (!value && value !== 0) return ''
    let intPart = Number(value).toFixed(0) // 获取整数部分
    if (type === 1) {
        intPart = Number(value).toFixed(1) // 保留1位小数
    } else if (type === 2) {
        intPart = Number(value).toFixed(2) // 保留1位小数
    }
    return intPart
}
